import React, { Component } from 'react'
import { Query } from 'react-apollo'

import { PORTAL_ORDER_QUERY } from '../../queries'

import { Container } from './styles'

import Product from '../../components/Product/'
import ProductIntro from '../../components/ProductIntro/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'

class ProductGrid extends Component {
  render() {
    if (!this.props.portalOrderId) {
      return (
        <Container full>
          {this.props.image ? (
            <ProductIntro title={this.props.title} image={this.props.image} description={this.props.description} />
          ) : null}
          {this.props.products.map((product, index) => {
            if (!product.portalProduct) {
              return null
            }
            return (
              <Product updateOrder={this.props.updateOrder} key={product.id} product={product} />
            )
          })}
        </Container>
      )
    }

    return (
      <Query query={PORTAL_ORDER_QUERY} variables={{ id: this.props.portalOrderId }}>
        {({ loading, error, data }) => {
          if (loading) return <Loader from="75%" to="100%" fixed />
          if (error) return <Error error="uw bestellijst" />
          let order = {}
          let wholeOrder = {}
          let servicePackage = ''
          if (data) {
            data.portalOrder.orderParts.map(orderPart => {
              order[orderPart.product.id] = orderPart.amount
              return null
            })
            wholeOrder = data.portalOrder
            servicePackage = data.portalOrder.branch.servicePackage
          }
          return (
            <Container search={this.props.search} full>
              {this.props.image ? (
                <ProductIntro title={this.props.title} image={this.props.image} description={this.props.description} />
              ) : null}
              {this.props.products.map((product, index) => {
                if (!product.portalProduct) {
                  return null
                }
                return (
                  <Product
                    search={this.props.search}
                    updateOrder={this.props.updateOrder}
                    key={product.id}
                    product={product}
                    order={order[`${product.id}`]}
                    wholeOrder={wholeOrder}
                    orderId={this.props.orderId}
                    editOrder={wholeOrder.submitted ? false : this.props.editOrder}
                    servicePackage={servicePackage}
                />
                )
              })}
            </Container>
          )
        }}
      </Query>
    )
  }
}

export default ProductGrid



// WEBPACK FOOTER //
// ./src/containers/ProductGrid/index.js